export class ColetorCustos {
  codColetorCusto: string;
  nomeColetorCusto: string;
  status: string;
  descMensagem: string;
  idx: number;
}
